type RedirectRule = {
  pattern: RegExp
  getRedirectPath: (match: RegExpMatchArray) => string
}

const redirectRules: RedirectRule[] = [
  {
    pattern: /^\/(business|learning)\/playlist-details\/\d+$/,
    getRedirectPath: (match) => `/${match[1]}/playlists`,
  },
  {
    pattern: /^\/(business|learning)\/playlist\/content\/\d+\/\d+$/,
    getRedirectPath: (match) => `/${match[1]}/playlists`,
  },
]

export function getRedirectPathFrom404(pathname: string): string {
  for (const rule of redirectRules) {
    const match = pathname.match(rule.pattern)
    if (match) {
      return rule.getRedirectPath(match)
    }
  }
  return '/'
}
